// extracted by mini-css-extract-plugin
export var faqs = "FAQs-module--faqs--4b77d";